import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { FuseSharedModule } from '@fuse/shared.module';
import { LoginComponent } from './login.component';
import { JwtModule } from '@auth0/angular-jwt';
import { AccountService } from 'app/guards/account.service';
import { TokenInterceptorService } from 'app/guards/token-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UserInteractionModule } from 'app/services/user-interaction/user-interaction.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';


export function tokenGetter() {
    return localStorage.getItem(AccountService.TokenStorageKey);
}

@NgModule({
    declarations: [
        LoginComponent
    ],
    imports: [
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatProgressBarModule,
        MatIconModule,
        MatInputModule,
        FuseSharedModule,
        UserInteractionModule,
        JwtModule.forRoot({
            config: {
                tokenGetter: tokenGetter
            }
        })
    ],
    providers: [
        AccountService,
        TokenInterceptorService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptorService,
            multi: true
        }
    ]
})
export class LoginModule {
}
